export const config = {
    apiKey: "AIzaSyDME9yYuvEqlt2cyUUsLbTsS4dOcSO5QK4",
    authDomain: "braincap-labelers.firebaseapp.com",
    projectId: "braincap-labelers",
    storageBucket: "braincap-labelers.appspot.com",
    messagingSenderId: "929121464341",
    appId: "1:929121464341:web:13481b0cddfefca394de1c",
    measurementId: "G-N2J3CXEW6Q"
}
